import React from 'react'
import styles from './UIGamePlayerInfoBody.module.scss'

export interface UIGamePlayerInfoBodyProps {
    color: string
    isMyPlayer: boolean
    children: React.ReactNode[]
}

export const UIGamePlayerInfoBody = ({
    color,
    isMyPlayer,
    children,
}: UIGamePlayerInfoBodyProps) => (
    <div className={styles.container} style={{'--player-color': color} as React.CSSProperties}>
        {children}
    </div>
)
